import { makeAutoObservable } from "mobx";
import {
    deleteICDMedicalSupplyRequestForm,
    getICDMedicalSupplyRequestFormById,
    saveOrUpdate,
    pagingICDMedicalSupplyRequestForm,
    getAllICDMedicalSupplyRequestForms
} from 'app/services/ICDMedicalSupplyRequestFormService';

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { ICDMedicalSupplyRequestForm } from "app/common/Model/ICDMedicalSupplyRequestForm";
import { checkSearchObject } from "app/common/LocalFunction";

export default class ICDMedicalSupplyRequestFormStore {
    listAllICDMedicalSupplyRequestForm = [];
    searchICDMedicalSupplyRequestForm = new SearchObject();
    pageICDMedicalSupplyRequestForm = null;
    selectedICDMedicalSupplyRequestForm = null;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllICDMedicalSupplyRequestForms = async () => {
        return await getAllICDMedicalSupplyRequestForms()
            .then(({ data }) => {
                this.listAllICDMedicalSupplyRequestForm = data || [];
            })
            .catch(error => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi", "Thông báo");
            })
    }
    pagingICDMedicalSupplyRequestForm = async () => {
        return await pagingICDMedicalSupplyRequestForm(this.searchICDMedicalSupplyRequestForm)
            .then(({ data }) => {
                this.pageICDMedicalSupplyRequestForm = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi", "Thông báo")
            })
    }

    handleChangeFormSearch = (searchICDMedicalSupplyRequestForm) => {
        this.searchICDMedicalSupplyRequestForm = checkSearchObject(this.searchICDMedicalSupplyRequestForm, searchICDMedicalSupplyRequestForm);
        this.pagingICDMedicalSupplyRequestForm();
    }

    handleOpenFormCreateOrEdit = (iCDMedicalSupplyRequestFormId) => {
        if (Boolean(iCDMedicalSupplyRequestFormId)) {
            getICDMedicalSupplyRequestFormById(iCDMedicalSupplyRequestFormId).then(({ data }) => {
                this.selectedICDMedicalSupplyRequestForm = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedICDMedicalSupplyRequestForm = new ICDMedicalSupplyRequestForm();
            this.openFormCreateOrEdit = true;
        }
    }

    saveOrUpdateICDMedicalSupplyRequestForm = (iCDMedicalSupplyRequestForm, { setSubmitting }) => {
        saveOrUpdate(iCDMedicalSupplyRequestForm)
            .then(() => {
                this.selectedICDMedicalSupplyRequestForm = null;
                toast.success("Lưu dữ liệu thành công!");
                this.handleClosePopup();
                this.pagingICDMedicalSupplyRequestForm();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu dữ liệu có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (iCDMedicalSupplyRequestForm) => {
        this.selectedICDMedicalSupplyRequestForm = { id: iCDMedicalSupplyRequestForm?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteICDMedicalSupplyRequestForm(this.selectedICDMedicalSupplyRequestForm?.id)
            .then(() => {
                if (this.searchICDMedicalSupplyRequestForm?.pageIndex > 1 && this.pageICDMedicalSupplyRequestForm?.content?.length === 1) {
                    this.searchICDMedicalSupplyRequestForm.pageIndex -= 1;
                }
                toast.success("Xóa bản ghi thành công!");
                this.handleClosePopup();
                this.pagingICDMedicalSupplyRequestForm();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa bản ghi có lỗi", "Thông báo");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchICDMedicalSupplyRequestForm = new SearchObject();
        this.pageICDMedicalSupplyRequestForm = null;
        this.selectedICDMedicalSupplyRequestForm = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    //for choosing iCDMedicalSupplyRequestForm in ChooseICDMedicalSupplyRequestFormPopup.jsx 
    listICDMedicalSupplyRequestForm = [];
    iCDMedicalSupplyRequestFormIdSet = null;

    isValidICDMedicalSupplyRequestForm = iCDMedicalSupplyRequestForm => {
        if (iCDMedicalSupplyRequestForm && iCDMedicalSupplyRequestForm?.id) return true;
        console.error("Invalid manipulated element");
        return false;
    }

    addICDMedicalSupplyRequestForm = iCDMedicalSupplyRequestForm => {
        if (!this.isValidICDMedicalSupplyRequestForm(iCDMedicalSupplyRequestForm)) return;
        this.listICDMedicalSupplyRequestForm.push(iCDMedicalSupplyRequestForm);
        this.iCDMedicalSupplyRequestFormIdSet.add(iCDMedicalSupplyRequestForm?.id);
    }

    initializelistICDMedicalSupplyRequestForm = iCDMedicalSupplyRequestForms => {
        this.iCDMedicalSupplyRequestFormIdSet = new Set();
        this.listICDMedicalSupplyRequestForm = [];
        if (iCDMedicalSupplyRequestForms && iCDMedicalSupplyRequestForms?.length > 0) {
            for (let i = 0; i < iCDMedicalSupplyRequestForms.length; i++) {
                this.addICDMedicalSupplyRequestForm(iCDMedicalSupplyRequestForms[i]);
            }
        }
    }

    removeICDMedicalSupplyRequestForm = iCDMedicalSupplyRequestForm => {
        if (!this.isValidICDMedicalSupplyRequestForm(iCDMedicalSupplyRequestForm)) return;
        if (this.iCDMedicalSupplyRequestFormIdSet.has(iCDMedicalSupplyRequestForm?.id)) {
            this.iCDMedicalSupplyRequestFormIdSet.delete(iCDMedicalSupplyRequestForm?.id);
        }
        else {
            console.error("Element is not exist");
        }
    }

    isExist = iCDMedicalSupplyRequestForm => {
        if (!this.isValidICDMedicalSupplyRequestForm(iCDMedicalSupplyRequestForm)) return;
        return this.iCDMedicalSupplyRequestFormIdSet.has(iCDMedicalSupplyRequestForm?.id);
    }

    getICDMedicalSupplyRequestFormIdSet = () => {
        return this.iCDMedicalSupplyRequestFormIdSet;
    }

    getListICDMedicalSupplyRequestForm = () => {
        const bufferIdSet = new Set();
        const data = [];
        if (this.listICDMedicalSupplyRequestForm && this.listICDMedicalSupplyRequestForm?.length > 0) {
            for (let i = 0; i < this.listICDMedicalSupplyRequestForm.length; i++) {
                const iCDMedicalSupplyRequestForm = this.listICDMedicalSupplyRequestForm[i];
                if (this.isExist(iCDMedicalSupplyRequestForm) && !bufferIdSet.has(iCDMedicalSupplyRequestForm?.id)) {
                    data.push(iCDMedicalSupplyRequestForm);
                    bufferIdSet.add(iCDMedicalSupplyRequestForm?.id);
                }
            }
        }
        this.listICDMedicalSupplyRequestForm = data;
        return data;
    }

}
